import { Injectable, signal } from '@angular/core';
import { IReservation } from '../interfaces/IReservation';

@Injectable({
  providedIn: 'root'
})
export class ReservationsStore {

  public readonly selectedShowReservations = signal<IReservation[]>([]);
  public readonly rebookReservation = signal<{transactionId: number; seatIds: number[]}>(null);
}
